import { useSidebar } from "@/components/ui/sidebar";

/** Closes the sidebar sheet on small screens after a link was followed. */
export const useCloseMobile = () => {
  const { openMobile, setOpenMobile } = useSidebar();
  return () => {
    if (openMobile) setOpenMobile(false);
  };
};
